import { BaseSyntheticEvent, PropsWithChildren, useContext } from 'react';

import { useAppDispatch } from '../../../../../../store/hooks';
import { rootActions } from '../../../../../../store/slices/root.slice';
import { ApkInfoModel } from '../../../../models/apk-info.model';
import { uploadApkFiles } from '../../../../thunks/upload-apk-files.thunk';
import { SnackBarContext } from '../../../snack-bar-context/SnackBarContext';
import { DragAndDropProps } from '../../models/drag-and-drop.model';
import { preventDefaults } from '../../util/prevent-defaults/prevent-defaults.util';

export const useHandleApkFileChange = (
  callbackFunction: (file: File) => void,
  props: PropsWithChildren<DragAndDropProps>
): ((event: BaseSyntheticEvent) => void) => {
  const dispatch = useAppDispatch();
  const snackBarCtx = useContext(SnackBarContext);
  const errorMsg = 'Something went wrong while uploading the file!';

  const onError = (): void => {
    snackBarCtx?.changeSeverity?.('error');
    snackBarCtx?.changeMessage(
      !props.apkInfo
        ? errorMsg
        : `${errorMsg} Please check again APK fields format`
    );
    snackBarCtx?.isOpen?.(true);
  };

  const onSuccess = (): void => {
    snackBarCtx?.changeSeverity?.('success');
    snackBarCtx?.changeMessage('File upload success!');
    snackBarCtx?.isOpen?.(true);
  };
  return async (event: BaseSyntheticEvent): Promise<void> => {
    preventDefaults(event);
    if (event.target.files && event.target.files.length > 0) {
      const targetFiles: File[] = Array.from(event.target.files);
      for (const element of targetFiles) {
        await dispatch(
          uploadApkFiles({
            file: element,
            onFileUploadCallback: callbackFunction,
            onFileRequestCallback: props.uploadHandler,
            fileType: props.fileType,
            splitIntoChunks: !!props.splitIntoChunks,
            onError,
            onSuccess,
            appId: props.featureId as number,
            apkInfo: props.apkInfo as ApkInfoModel,
          })
        )
          .unwrap()
          .catch(() => {
            onError();
            dispatch(rootActions.toggleApkFileUploadVisibility());
          });
      }
    }
  };
};
